<ng-container *ngIf="data$ | async as data">
  <header class="header">
    <div class="header-info">
      <div [style.backgroundColor]="data.realtor.headerColor" class="header-info-top">
        <div class="header-info-headers">
          <h3 [ngStyle]="{fontSize:fontSize}">
            {{ data.realtor.fullName }}</h3>
          <div class="dot">&middot;</div>
          <h3 [ngStyle]="{fontSize:fontSize}">
            {{ data.realtor.companyName }}</h3>
        </div>
      </div>
    </div>
    <div class="header-logo">
      <div class="header-logo-img">
        <div class="img-container"
          [ngStyle]="{'background-image': 'url(' + data.realtor.companyLogoUrl + ')'}">
        </div>
        <!-- <img 
          *ngIf="data.realtor.companyLogoUrl" 
          [src]="data.realtor.companyLogoUrl" 
          alt="Real Estate Partners"> -->
      </div>
    </div>
  </header>
  <table class="offer-content-table">
    <thead>
      <tr>
        <td>
          <div class="header-space">&nbsp;</div>
        </td>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>
          <main>
            <section class="main-section">
              <div class="main-letter">
                <div class="recepient-name">
                  <div class="date">{{ currentDate | date:'longDate' }}</div>
                  <div class="name">{{ data.offer.recipientName }}</div>
                </div>
                <h2>{{ data.offer.subject }}</h2>
                <pre class="letter">{{ data.offer.letter }}</pre>
              </div>

              <div class="buyers">
                <h2 [style.color]="data.realtor.headerColor" *ngIf="!data.offer.isRealtorPictureUsed">{{buyerTypeText}}
                </h2>

                <div class="buyers-image">
                  <!-- <div class="image-container"
                  [style.background-image]="'url('+(data.offer.letterPhotoUrl)+')'"
                  ></div> -->
                  <img class="buyer-image-elm" *ngIf="data.offer.letterPhotoUrl as src" [src]="src"
                    alt="Cover Letter Photo">
                </div>
                <h4 class="buyers-name">{{buyersNameText}}</h4>
                <ng-container *ngIf="data.offer.borrowerQuote as quote">
                  <div class="quotes-image">
                    <mat-icon class="quotes-icon" [style.color]="data.realtor.headerColor" svgIcon="quotes"></mat-icon>
                  </div>
                  <div class="quote">
                    <p [style.color]="data.realtor.headerColor">{{ quote }}</p>
                  </div>
                </ng-container>
              </div>
            </section>

            <section class="summary-section">
              <h2>Offer Summary</h2>

              <table class="summary-table">
                <tr>
                  <td class="summary-table-image">

                    <mat-icon [style.fill]="data.realtor.headerColor" svgIcon="offer_price"></mat-icon>
                  </td>
                  <td class="summary-table-column-title">Offer Price</td>
                  <td class="summary-table-info">
                    <div class="cell-content">
                      <span>{{ data.offer.price | currency }}</span>
                    </div>
                  </td>
                  <td class="summary-table-title"><span>Notes</span></td>
                  <td class="summary-table-notes"><span>{{ data.offer.priceNotes}}</span></td>
                </tr>
                <tr>
                  <td class="summary-table-image">
                    <mat-icon [style.fill]="data.realtor.headerColor" svgIcon="escrow_holder"></mat-icon>
                  </td>
                  <td class="summary-table-column-title">Close of Escrow</td>
                  <td class="summary-table-info">{{ data.offer.escrowCompany }}</td>
                  <td></td>
                  <td></td>
                </tr>

                <tr>
                  <td class="summary-table-image">
                    <mat-icon [style.fill]="data.realtor.headerColor" svgIcon="contingencies"></mat-icon>
                  </td>
                  <td class="summary-table-column-title">Appraisal Contingency</td>
                  <td class="summary-table-info">{{ data.offer.contingency }}</td>
                  <td></td>
                  <td></td>
                </tr>

                <tr>
                  <td class="summary-table-image">
                    <mat-icon [style.fill]="data.realtor.headerColor" svgIcon="contigency_loan"></mat-icon>
                  </td>
                  <td class="summary-table-column-title">Loan Contingency</td>
                  <td class="summary-table-info">{{ data.offer.contingencyLoan || "" }}</td>
                  <td></td>
                  <td></td>
                </tr>

                <tr>
                  <td class="summary-table-image">
                    <mat-icon [style.fill]="data.realtor.headerColor" svgIcon="contingencies"></mat-icon>
                  </td>
                  <td class="summary-table-column-title">General Contingency</td>
                  <td class="summary-table-info">{{ data.offer.contingencyGeneral || "" }}</td>
                  <td></td>
                  <td></td>
                </tr>

                <tr>
                  <td class="summary-table-image">
                    <mat-icon [style.fill]="data.realtor.headerColor" svgIcon="deposit"></mat-icon>
                  </td>
                  <td class="summary-table-column-title">Deposit</td>
                  <td class="summary-table-info">
                    <div class="cell-content">
                      <span>{{ data.offer.deposit | currency }}</span>
                    </div>
                  </td>
                  <td class="summary-table-title"><span>Notes</span></td>
                  <td class="summary-table-notes"><span>{{ data.offer.depositNotes}}</span></td>
                </tr>

                <tr>
                  <td class="summary-table-image">
                    <mat-icon [style.fill]="data.realtor.headerColor" svgIcon="down_payment"></mat-icon>
                  </td>
                  <td class="summary-table-column-title">Down Payment</td>
                  <td class="summary-table-info">
                    <span *ngIf="data.offer.downPaymentType === downPaymentTypes.Percent; else currency">
                      {{ data.offer.downPayment }}%
                    </span>
                    <ng-template #currency>
                      {{ data.offer.downPayment | currency }}
                    </ng-template>
                  </td>
                  <td></td>
                  <td></td>
                </tr>

                <tr>
                  <td class="summary-table-image">
                    <mat-icon [style.fill]="data.realtor.headerColor" svgIcon="lender"></mat-icon>
                  </td>
                  <td class="summary-table-column-title">Lender</td>
                  <td class="summary-table-info">{{ data.offer.lender }}</td>
                  <td></td>
                  <td></td>
                </tr>

                <tr>
                  <td class="summary-table-image">
                    <mat-icon [style.fill]="data.realtor.headerColor" svgIcon="financing"></mat-icon>
                  </td>
                  <td class="summary-table-column-title">Financing</td>
                  <td class="summary-table-info">{{ data.offer.financing | currency }}</td>
                  <td></td>
                  <td></td>
                </tr>

                <tr>
                  <td class="summary-table-image">
                    <mat-icon [style.fill]="data.realtor.headerColor" svgIcon="timer"></mat-icon>
                  </td>
                  <td class="summary-table-column-title">Offer Response Deadline</td>
                  <td class="summary-table-info">{{ data.offer.responseDeadline | date:'mediumDate' }}</td>
                  <td></td>
                  <td></td>
                </tr>
              </table>

              <div class="summary-text">
                <pre>{{ data.offer.letterConclusion }}</pre>
              </div>
              <div class="summary-signatures">
                <div class="summary-signature">
                  <div class="image">
                    <div class="image-container" [style.background-image]="'url('+(data.realtor.signatureUrl)+')'">
                    </div>
                    <!-- <img [src]="data.offer.realtorOfferSignature" alt="Realtor offer signature"> -->
                  </div>
                  <h5 class="name">{{ data.realtor.fullName }}</h5>
                  <p class="hint">Realtor</p>
                  <p class="hint" *ngIf="data.realtor.licenseNumber != null">License No. : {{ data.realtor.licenseNumber }}</p>
                </div>
                <div class="summary-signature">
                  <div class="image" *ngIf="data.offer.borrower.isLoanOfficerIndependent == false">
                    <div class="image-container"
                      [style.background-image]="'url('+(data.borrower.loanOfficer.signatureUrl)+')'" *ngIf="data.offer.borrower.isLoanOfficerIndependent == false"></div>
                    <!-- <img [src]="data.offer.loanOfficerOfferSignature" alt="Loan officer offer signature"> -->
                  </div>
                  <h5 class="name" *ngIf="data.offer.borrower.isLoanOfficerIndependent == false">{{ data.offer.loanOfficer.fullName }}</h5>
                  <h5 class="name" *ngIf="data.offer.borrower.isLoanOfficerIndependent == true">There is no associated loan officer</h5>
                  <p class="hint">Loan Officer</p>
                </div>
              </div>
            </section>

            <ng-container *ngIf="data.borrower.preApproval.id != null && data.borrower.isLoanOfficerIndependent == false">
            <ng-container *ngFor="let asset of repositionAssets(data.borrower.preApprovalAssets)">
              <ng-container *ngIf="asset.fileUrl">
                <section *ngFor="let file of asset.files" class="documents-section large-doc">
                  <ng-container *ngIf="((asset.assetTypeId !== assetType.PreApprovalLetter) && (asset.assetTypeId !== assetType.PreApprovalCustom)); else preApprovalLetterContainer">
                    <h2>Supporting Documents</h2>
                    <h5>{{ asset.alternateName != '' && asset.alternateName != null ? asset.alternateName : asset.assetTypeName }}</h5>
                    <div class="document-wrapper large-doc">
                      <img [src]="file.url" alt="{{ file.name }}">
                    </div>
                  </ng-container>
                  <ng-template #preApprovalLetterContainer>
                    <ng-container *ngIf="isNotPdf(file.name) && data.borrower.isCustom && asset.assetTypeId == assetType.PreApprovalCustom; else preApprovalLetter"><!--isNotPdf(asset.fileUrl) && -->
                      <ng-container>
                        <ng-container *ngIf="asset.fileUrl">
                              <!--<h2>Supporting Documents</h2>-->
                              <h5 *ngIf="asset.assetTypeId != 7">{{ asset.alternateName != '' && asset.alternateName != null ? asset.alternateName : asset.assetTypeName }}</h5>
                    <h5 *ngIf="asset.assetTypeId == 7">Pre-Approval Letter</h5>
                              <div class="document-wrapper large-doc">
                                <img [src]="file.url" alt="{{ file.name }}">
                              </div>
                        </ng-container>
                      </ng-container>
                    </ng-container>
                  </ng-template>
                  <ng-template #preApprovalLetter>
                    <ng-container *ngIf="!data.borrower.isCustom && asset.assetTypeId === assetType.PreApprovalLetter">
                      <ng-container>
                        <ng-container *ngIf="asset.fileUrl">
                              <h2>Supporting Documents</h2>
                              <h5>{{ asset.assetTypeName }}</h5>
                              <div class="document-wrapper large-doc">
                                <img [src]="file.url" alt="{{ file.name }}">
                              </div>
                        </ng-container>
                      </ng-container>
                    </ng-container>
                  </ng-template>
                </section>
              </ng-container>
            </ng-container>
          </ng-container>

          <ng-container *ngIf="data.borrower.preApproval.id != null && data.borrower.isLoanOfficerIndependent == true">
            <ng-container *ngFor="let asset of data.borrower.preApprovalAssets">
                        <ng-container *ngIf="asset.fileUrl">
                              <!--<h2>Supporting Documents</h2>-->
                              <!--<h5 >Pre-Approval Package</h5>-->
                              <div class="document-wrapper large-doc">
                                <section *ngFor="let file of asset.files" class="documents-section large-doc">
                                    <!--<h2>Pre-Approval Package</h2>-->
                                    <h5>Pre-Approval Package</h5>
                                    <div class="document-wrapper large-doc">
                                      <img [src]="file.url" alt="{{ file.name }}">
                                    </div>
                                </section>
                              </div>
                        </ng-container>
                  </ng-container>
          </ng-container>

            <!-- <ng-container *ngFor="let asset of data.borrower.preApprovalAssets">
              <ng-container *ngIf="asset.fileUrl">
                <section *ngFor="let file of asset.files" class="documents-section large-doc">
                  <ng-container  *ngIf="data.borrower.preApproval.isCustomLetter && asset.assetTypeId === assetType.PreApprovalCustom; else preApprovalLetter">
                    <h2>Supporting Documents</h2>
                    <h5>{{ asset.assetTypeName }}</h5>
                    <div class="document-wrapper large-doc">
                      <img [src]="file.url" alt="{{ file.name }}">
                    </div>
                  </ng-container>
                  <ng-template #preApprovalLetter>
                    <ng-container *ngIf="!data.borrower.preApproval.isCustomLetter && asset.assetTypeId === assetType.PreApprovalLetter">
                      <h2>Supporting Documents</h2>
                      <h5>{{ asset.assetTypeName }}</h5>
                      <div class="document-wrapper large-doc">
                        <img [src]="file.url" alt="{{ file.name }}">
                      </div>
                    </ng-container>
                  </ng-template>
                </section>
              </ng-container>
            </ng-container>

            <ng-container *ngFor="let asset of data.borrower.preApprovalAssets">
              <ng-container *ngIf="asset.fileUrl">
                <section *ngFor="let file of asset.files" class="documents-section large-doc">
                  <ng-container *ngIf="asset.assetTypeId !== assetType.PreApprovalLetter && asset.assetTypeId !== assetType.PreApprovalCustom">
                    <h2>Supporting Documents</h2>
                    <h5>{{ asset.assetTypeName }}</h5>
                    <div class="document-wrapper large-doc">
                      <img [src]="file.url" alt="{{ file.name }}">
                    </div>
                  </ng-container>
                </section>
              </ng-container>
            </ng-container> -->
            
            <ng-container *ngFor="let asset of data.offerAssets.assets3">
              <ng-container *ngIf="!asset.isMultipart && asset.assetTypeId == 4">
                <section class="documents-section large-doc">
                  <h2>Supporting Documents</h2>
                  <h5>Additional Documents</h5>
                  <div class="document-wrapper large-doc">
                    <img *ngIf="asset"
                      [src]="asset.combineFileUrl" >
                  </div>
                </section>
              </ng-container>
            </ng-container>
            <ng-container *ngFor="let asset of data.offerAssets.assets3">
              <ng-container *ngIf="!asset.isMultipart && asset.assetTypeId == 5">
                <section class="documents-section large-doc">
                  <h2>Supporting Documents</h2>
                  <h5>Additional Documents</h5>
                  <div class="document-wrapper large-doc">
                    <img *ngIf="asset"
                      [src]="asset.combineFileUrl" >
                  </div>
                </section>
              </ng-container>
            </ng-container>
            <section class="documents-section large-doc">
              <ng-container *ngIf="data.offer.rpaUrl && (rpaExtension$ | async) as extension" [ngSwitch]="extension">
                <a target="_blank" class="download-rpa-btn" href="{{data.offer.rpaUrl}}">
                  <mat-icon svgIcon="file_download" style="position: relative; top: 5px;"></mat-icon> Purchase Contract
                </a>

                <arb-viewer-pdf *ngSwitchCase="'pdf'" class="rpa-pdf" [url]="data.offer.rpaUrl">

                  <ng-template #pageHeaderTemplate>
                    <h2>Supporting Documents</h2>
                    <div class="download-rpa-button-wrapper">
                      <h5>Purchase Contract</h5>
                    </div>
                  </ng-template>
                </arb-viewer-pdf>
                <ng-container *ngSwitchDefault>
                  <h2>Supporting Documents</h2>
                  <h5>Purchase Contract</h5>
                  <div class="document-wrapper large-doc">
                    <img class="document-image" [src]="data.offer.rpaUrl" alt="rpa">
                  </div>
                </ng-container>
              </ng-container>
            </section>
            
          </main>
        </td>
      </tr>
    </tbody>
    <tfoot>
      <tr>
        <td>
          <div class="footer-space">&nbsp;</div>
        </td>
      </tr>
    </tfoot>
  </table>
  <footer [style.backgroundColor]="data.realtor.footerColor" class="footer">
    <ul class="footer-info">
      <li>
        {{ data.realtor.fullName }}, {{ data.realtor.phoneNumber }},
        <a href="mailto:{{ data.realtor.email }}">{{ data.realtor.email }}</a>
      </li>
      <li>{{ data.realtor.officeAddress }}</li>
      <li><a href="{{ data.realtor.website }}">{{ data.realtor.website }}</a></li>
    </ul>
  </footer>
</ng-container>